import { createApp } from 'vue';
import TgsToPngConverter from '@/Components/TgsToPngConverter.vue';
import '@styles/app.css';

createApp(TgsToPngConverter).mount('#tgs-to-png-converter');
